import { render, staticRenderFns } from "./IconGoldCircle.vue?vue&type=template&id=7bedb034&scoped=true&"
import script from "./IconGoldCircle.vue?vue&type=script&lang=js&"
export * from "./IconGoldCircle.vue?vue&type=script&lang=js&"
import style0 from "./IconGoldCircle.vue?vue&type=style&index=0&id=7bedb034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bedb034",
  null
  
)

export default component.exports